class WholesalePortal {
  constructor() {
    this.initWholesaleMenu();
    this.initMegaMenus();
    this.initCarousels();
  }

  initWholesaleMenu() {
    const toggle = document.querySelector('[data-wh-menu-toggle]');
    const mobile = document.querySelector('[data-wh-mobile-menu]');
    const header = document.querySelector('.wh-header');
    if (!toggle || !mobile) return;

    toggle.addEventListener('click', () => {
      const isOpen = mobile.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      document.body.classList.toggle('menu-open', isOpen);
      header?.classList.toggle('menu-open', isOpen);
    });
  }

  initMegaMenus() {
    const triggers = document.querySelectorAll('[data-wh-mega-trigger]');
    if (!triggers.length) return;

    const closeAll = () => {
      triggers.forEach((item) => {
        item.classList.remove('is-open');
        const btn = item.querySelector('.wh-header__shop-link');
        const panel = item.querySelector('.wh-mega-menu');
        btn?.setAttribute('aria-expanded', 'false');
        panel?.setAttribute('hidden', '');
      });
    };

    triggers.forEach((item) => {
      const btn = item.querySelector('.wh-header__shop-link');
      const panel = item.querySelector('.wh-mega-menu');
      if (!btn || !panel) return;

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
        }
      });

      panel.querySelector('[data-wh-mega-close]')?.addEventListener('click', closeAll);
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.wh-header__shop-nav')) closeAll();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
  }

  initCarousels() {
    document.querySelectorAll('[data-wh-carousel]').forEach((carousel) => {
      const track = carousel.querySelector('[data-carousel-track]');
      const slides = carousel.querySelectorAll('[data-carousel-slide]');
      if (!track || slides.length < 2) return;

      const id = carousel.dataset.whCarousel;
      const prev = document.querySelector(`[data-carousel-prev="${id}"]`);
      const next = document.querySelector(`[data-carousel-next="${id}"]`);
      const interval = (parseInt(carousel.dataset.autoplay, 10) || 6) * 1000;
      let index = 0;
      let timer;

      const getVisible = () => {
        const w = window.innerWidth;
        if (w <= 749) return 1;
        if (w <= 989) return 2;
        if (w <= 1199) return 3;
        return parseInt(carousel.dataset.columns, 10) || 4;
      };

      const update = () => {
        const visible = getVisible();
        const maxIndex = Math.max(0, slides.length - visible);
        if (index > maxIndex) index = maxIndex;

        const slide = slides[0];
        const gap = parseFloat(getComputedStyle(track).gap) || 16;
        const slideWidth = slide.getBoundingClientRect().width + gap;
        track.style.transform = `translateX(-${index * slideWidth}px)`;

        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index >= maxIndex;
      };

      const go = (dir) => {
        const visible = getVisible();
        const maxIndex = Math.max(0, slides.length - visible);
        index = Math.min(Math.max(index + dir, 0), maxIndex);
        update();
      };

      prev?.addEventListener('click', () => go(-1));
      next?.addEventListener('click', () => go(1));
      window.addEventListener('resize', update);

      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!prefersReduced) {
        const autoplay = () => {
          const visible = getVisible();
          const maxIndex = Math.max(0, slides.length - visible);
          index = index >= maxIndex ? 0 : index + 1;
          update();
        };
        timer = setInterval(autoplay, interval);
        carousel.addEventListener('mouseenter', () => clearInterval(timer));
        carousel.addEventListener('mouseleave', () => {
          timer = setInterval(autoplay, interval);
        });
      }

      update();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.wh-header') || document.querySelector('[data-wh-carousel]')) {
    new WholesalePortal();
  }
});
